import {useEffect, useMemo, useState} from "react";
import PlusIcon from "../../assests/images/dashboard/Vector 2.png";
import {useSelector} from "react-redux";
import {BtnLoader} from "src/commonLoader/index";
import {GRAPHQL_ENDPOINT, S3_BASE_URL} from "src/constants/endpoints";
import {useAxiosInterceptor} from "src/hooks/useAxiosInterceptor";
import Dropzone from "react-dropzone";
import {useFormik} from "formik";
import DeleteIcon from "../../assests/images/dashboard/delete.png";
import ComboItemsModal from "src/components/ComboItemsModal/ComboItemsModal";
import UpdateComboItemCard from "src/components/ComboCard/UpdateComboItemCard";
import {UPDATE_COMBO, UPLOAD_COMBO_IMAGE} from "src/constants/mutations";
import {GET_COMBOS} from "src/constants/queries";
import {useLocation, useNavigate} from "react-router-dom";
import {useAuth} from "src/contexts/auth-provider";
import RestuarantImg from "../../assests/images/dashboard/test.png";
import {mimeTypeToExtension} from "src/components/RestaurantSetting/RestaurantSettingComponent";
import axios from "axios";
import {convertDollarToCents, formatCentsToDollarsWithDollarSign} from "../../helpers";
import { successToast } from "src/utils/toasts";
import { restaurantSegment } from "src/utils/restaurantUrl";
import MenuItemLocaleFields from "src/components/common/MenuItemLocaleFields";
import { useStorePosLocales } from "src/hooks/useStorePosLocales";
import {
  buildLocaleTranslationMap,
  buildTranslationsPayload,
  LocaleTranslationMap,
  syncLegacyFieldsFromLocaleTranslations,
} from "src/utils/localeTranslations";

const UpdateCombo = () => {
  const location = useLocation();
  const initialComboData = location.state?.comboData || {};
  const locationId =
      location.pathname?.split("/")[location.pathname.split("/").length - 1];
  const [comboData, setComboData] = useState(initialComboData);
  const { enabledLocaleOptions, enabledLocales, defaultLocale } = useStorePosLocales();
  const initialLocaleTranslations = useMemo(
    () =>
      buildLocaleTranslationMap(comboData?.translations, enabledLocales, {
        englishName: comboData?.englishName,
        nonEnglishName: comboData?.nonEnglishName,
        englishDescription: comboData?.englishDescription,
        nonEnglishDescription: comboData?.nonEnglishDescription,
      }),
    [comboData, enabledLocales]
  );
  const [localeTranslations, setLocaleTranslations] = useState<LocaleTranslationMap>(initialLocaleTranslations);
  const [localeDirty, setLocaleDirty] = useState(false);
  const { axBe } = useAxiosInterceptor();
  const { isComboLoading } = useSelector((state: any) => state.combo);
  const [showItemModal, setShowItemModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [uploadImage, setUploadImage] = useState<any>(null);
  const [uploadImageLoader, setUploadImageLoader] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [priceDisplay, setPriceDisplay] = useState("$0.00");
  const navigate = useNavigate();
  const { user, hasRestaurant } = useAuth();

  const formik = useFormik({
    initialValues: {
      englishName: "",
      nonEnglishName: "",
      englishDescription: "",
      nonEnglishDescription: "",
      priceCents: 0,
      taxRate: 0,
      itemCorrelationIds: [],
      isActive: true,
    },
    onSubmit: () => {},
  });

  const testData = formik.values.itemCorrelationIds;

  const {setFieldValue} = formik;

  useEffect(() => {
    const fetchComboData = async () => {
      if (locationId && hasRestaurant?.correlationId) {
        try {
          const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
            query: GET_COMBOS,
            variables: {
              storeCorrelationId: hasRestaurant.correlationId,
              activeFilter: "ALL",
            },
          });
          
          const combos = data?.data?.combosByStoreCorrelationId || [];
          const currentCombo = combos.find((c: any) => c.correlationId === locationId);
          
          if (currentCombo) {
            setComboData(currentCombo);
          }
        } catch (error) {
          console.error("Error fetching combo data:", error);
        }
      }
    };

    fetchComboData();
  }, [locationId, hasRestaurant?.correlationId, axBe]);

  useEffect(() => {
    setLocaleTranslations(initialLocaleTranslations);
    setLocaleDirty(false);
  }, [initialLocaleTranslations]);

  // Initialize form data when comboData is available
  useEffect(() => {
    if (comboData?.correlationId) {
      setFieldValue("englishName", comboData?.englishName);
      setFieldValue("taxRate", comboData?.taxRate);
      setFieldValue("nonEnglishName", comboData?.nonEnglishName);
      setFieldValue("englishDescription", comboData?.englishDescription);
      setFieldValue("nonEnglishDescription", comboData?.nonEnglishDescription);
      setFieldValue("priceCents", comboData?.priceCents);
      setFieldValue("itemCorrelationIds", comboData?.itemList);
      setFieldValue("isActive", comboData?.active !== false);
      setImageUrl(S3_BASE_URL + comboData?.bucketKeyName);

      // Initialize display value from comboData
      setPriceDisplay(formatCentsToDollarsWithDollarSign(comboData?.priceCents || 0));
    }
  }, [comboData, setFieldValue]);

  const isFormDirty = formik.dirty || localeDirty;
  const defaultLocaleName = localeTranslations[defaultLocale]?.name?.trim() ?? "";
  const canSave = defaultLocaleName.length > 0 && isFormDirty;

  const updateCombo = async () => {
    setLoading(true);
    try {
      const legacy = syncLegacyFieldsFromLocaleTranslations(localeTranslations);
      const translations = buildTranslationsPayload(localeTranslations, enabledLocales);
      let variables: any = {};
      const itemsId = formik.values.itemCorrelationIds.map((item: any) => {
        return item.correlationId;
      });

      variables = {
        updateComboInput: {
          comboCorrelationId: locationId,
          englishDescription: legacy.englishDescription || undefined,
          englishName: legacy.englishName || undefined,
          itemCorrelationIds: itemsId.length > 0 ? itemsId : undefined,
          nonEnglishDescription: legacy.nonEnglishDescription || undefined,
          nonEnglishName: legacy.nonEnglishName || undefined,
          taxRate: formik.values.taxRate || undefined,
          priceCents: formik.values.priceCents ? Number(formik.values.priceCents) : undefined,
          isActive: formik.values.isActive,
          translations,
        },
      };
      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: UPDATE_COMBO,
        variables: variables,
      });
      if (data?.errors?.length) {
        throw data?.errors;
      }

      successToast("Combo updated successfully!");
      setLoading(false);
      setLocaleDirty(false);
      
      // Small delay to allow user to see the updated price overrides before navigating
      setTimeout(() => {
        navigate(`/restaurants/${restaurantSegment(hasRestaurant?.correlationId ?? "", hasRestaurant?.name)}/combo`);
      }, 1000);
    } catch (error) {
      console.error("Error creating user:", error);
      setLoading(false);
    }
  };

  const comboDelete = async () => {
    setDeleteLoader(true);
    try {
      let variables: any = {};
      variables = {
        updateComboInput: {
          comboCorrelationId: locationId,
          isActive: false,
        },
      };
      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: UPDATE_COMBO,
        variables: variables,
      });

      if (data?.errors?.length) {
        throw data?.errors;
      }
      setDeleteLoader(false);
      navigate(`/restaurants/${restaurantSegment(hasRestaurant?.correlationId ?? "", hasRestaurant?.name)}/combo`);
    } catch (error) {
      console.error("Error creating user:", error);
      setLoading(false);
      setDeleteLoader(false);
    }
  };

  const handleRemoveItem = (combo: any) => {
    const tempItemCorrelationIds = [...formik.values.itemCorrelationIds];
    const index = tempItemCorrelationIds.findIndex(
        (data: any) => data.correlationId === combo.correlationId
    );
    tempItemCorrelationIds.splice(index, 1);
    formik.setFieldValue("itemCorrelationIds", tempItemCorrelationIds);
  };

  const handleFileChange = (file: any) => {
    setUploadImage({
      url: URL.createObjectURL(file),
      file,
    });
  };

  const uploadComboImage = async () => {
    setUploadImageLoader(true);
    const variables = {
      createComboPreSignedUrlInput: {
        storeUserCorrelationId: user?.storeUser?.correlationId,
        storeCorrelationId: hasRestaurant.correlationId,
        comboName: localeTranslations[defaultLocale]?.name?.trim() || syncLegacyFieldsFromLocaleTranslations(localeTranslations).englishName,
        fileNameExtension: mimeTypeToExtension[uploadImage?.file?.type],
        comboCorrelationId: locationId,
      },
    };
    try {
      const res = await axBe.post(GRAPHQL_ENDPOINT, {
        query: UPLOAD_COMBO_IMAGE,
        variables: variables,
      });
      if (!res?.data?.error?.length) {
        const awsUrl =
            res.data?.data?.createUploadPreSignedUrlForCombo?.preSignedUrl;
        await axios.put(awsUrl, uploadImage.file, {
          headers: {
            "Content-Type": uploadImage?.file?.type,
            "x-amz-acl": "public-read",
          },
        });
        setUploadImageLoader(false);
        navigate(`/restaurants/${restaurantSegment(hasRestaurant?.correlationId ?? "", hasRestaurant?.name)}/combo`);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setUploadImageLoader(false);
    }
  };

  return (
      <>
        <div>
          <div className="flex justify-between items-center">
            <div className="flex gap-x-4 items-center">
              <Dropzone
                  accept={{
                    "image/png": [".png"],
                    "image/jpg": [".jpg"],
                    "image/jpeg": [".jpeg"],
                  }}
                  onDrop={(acceptedFiles) => handleFileChange(acceptedFiles[0])}
              >
                {({ getRootProps, getInputProps }) => (
                    <>
                      <div className="relative w-[61px] h-[61px] rounded-full border border-[#F1F1F2]">
                        <img
                            className="absolute object-cover h-full w-full rounded-full"
                            src={uploadImage?.url || imageUrl || RestuarantImg}
                            alt=""
                        />
                      </div>
                      {uploadImage?.url ? (
                          <>
                            {uploadImageLoader ? (
                                <div>
                                  <BtnLoader />
                                </div>
                            ) : (
                                <button
                                    className="text-sm text-orange bg-[#FD76571A] rounded-lg px-3 py-[10px]"
                                    onClick={uploadComboImage}
                                >
                                  Upload
                                </button>
                            )}
                          </>
                      ) : (
                          <button
                              className="text-sm text-orange bg-[#FD76571A] rounded-lg px-3 py-[10px]"
                              {...getRootProps()}
                          >
                            Select new image
                            <input {...getInputProps()} />
                          </button>
                      )}
                    </>
                )}
              </Dropzone>
              {uploadImage?.url && (
                  <img
                      className="w-[18px] h-[20px] cursor-pointer"
                      src={DeleteIcon}
                      alt="Delete"
                      onClick={() => setUploadImage(null)}
                  />
              )}
            </div>
            <div className="flex justify-end items-center gap-x-2 mt-2">
              {loading ? (
                  <BtnLoader />
              ) : (
                  <button
                      className={`${
                          !canSave && "opacity-20"
                      } h-[40px] bg-[#FD7657] px-8 text-sm text-white rounded-xl flex justify-center items-center cursor-pointer`}
                      onClick={updateCombo}
                      disabled={!canSave}
                  >
                    Update
                  </button>
              )}
              {deleteLoader ? (
                  <BtnLoader />
              ) : (
                  <div
                      className="h-[42px] px-6 text-sm text-[#FD7657] rounded-xl bg-[#FEF5F4] flex gap-x-2 items-center cursor-pointer"
                      onClick={comboDelete}
                  >
                    <img
                        className="w-[12px] h-[13px]"
                        src={DeleteIcon}
                        alt="Delete"
                    />
                    Delete
                  </div>
              )}
            </div>
          </div>
          <div className="w-full flex gap-3 mt-4">
            <div className="w-[90px]">
              <div
                  className="h-[240px] bg-white rounded-xl flex justify-center items-center cursor-pointer"
                  onClick={() => setShowItemModal(!showItemModal)}
              >
                <img className="w-[17px] h-[17px] " src={PlusIcon} alt="" />
              </div>
            </div>
            <div className="w-full">
              {isComboLoading ? (
                  <div className="flex items-center justify-center w-full h-full">
                    <BtnLoader />
                  </div>
              ) : testData && testData.length > 0 ? (
                  <div className="flex flex-wrap">
                    {testData?.map((combo: any, index: any) => (
                        <UpdateComboItemCard
                            key={index}
                            combo={combo}
                            handleRemoveItem={handleRemoveItem}
                        />
                    ))}
                  </div>
              ) : (
                  <div className="absolute top-[27%] left-[35%]">
                    <p>Click the button on the left to create some combo!</p>
                  </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex w-full justify-center">
          <div
              className={`bg-white rounded-lg w-[100%] relative mt-3 ${
                  enabledLocaleOptions.length > 1 ? "min-h-[600px]" : "min-h-[420px]"
              }`}
          >
            <div className="pb-4 pt-4 w-[95%] m-auto">
              <MenuItemLocaleFields
                enabledLocaleOptions={enabledLocaleOptions}
                defaultLocale={defaultLocale}
                localeTranslations={localeTranslations}
                onChange={(next: LocaleTranslationMap) => {
                  setLocaleTranslations(next);
                  setLocaleDirty(true);
                }}
                entityLabel="Combo"
              />
              <div className="flex gap-x-2 mt-4">
                <div className="w-full mt-2">
                  <label className="block text-sm font-medium text-[#9B9B9B] p-1">
                    Combo Price
                  </label>
                  <input
                      name="priceDisplay"
                      type="text"
                      className="h-[40px] text-xs w-full border rounded-lg border-[#F1F1F2] mt-1 px-2"
                      placeholder="Enter price"
                      value={priceDisplay}
                      onChange={(e) => {
                        setPriceDisplay(e.target.value);
                      }}
                      onBlur={(e) => {
                        const cents = convertDollarToCents(e.target.value);
                        formik.setFieldValue("priceCents", cents);
                        setPriceDisplay(formatCentsToDollarsWithDollarSign(cents));
                      }}
                      onFocus={(e) => {
                        if (e.target.value.startsWith('$')) {
                          setPriceDisplay(e.target.value.substring(1));
                        }
                      }}
                  />
                </div>
                <div className="w-full mt-2">
                  <label className="block text-sm font-medium text-[#9B9B9B] p-1">
                    Tax Rate (Decimal)
                  </label>
                  <input
                      className="h-[40px] text-xs w-full border rounded-lg border-[#F1F1F2] mt-1 px-2"
                      type="number"
                      name="taxRate"
                      id="taxRate"
                      value={formik.values.taxRate ?? ""}
                      onBlur={formik.handleBlur}
                      step="0.0001"
                      min="0"
                      max="1"
                      onChange={(e) => {
                        let val = e.target.value;
                        if (val.includes(".")) {
                          const [intPart, decimalPart] = val.split(".");
                          if (decimalPart.length > 4) {
                            val = intPart + "." + decimalPart.slice(0, 4);
                          }
                        }
                        const numericValue = parseFloat(val);
                        if (!isNaN(numericValue) && numericValue > 1) {
                          val = "1";
                        }
                        formik.setFieldValue("taxRate", val);
                      }}
                  />
                  {formik.touched.taxRate && formik.errors.taxRate ? (
                      <div className="text-orange text-xs mt-2">
                        {formik.errors.taxRate}
                      </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="pb-4 pt-4 w-[95%] m-auto">
              <div className="mt-4 pl-1">
                <label className="flex items-center gap-2 cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={formik.values.isActive !== false}
                    onChange={(e) => formik.setFieldValue("isActive", e.target.checked)}
                    className="receipt-lang-check w-6 h-6 min-w-[24px] min-h-[24px] shrink-0 rounded border border-[#9B9B9B] cursor-pointer appearance-none"
                  />
                  <span className="text-sm">Combo is active (visible on customer menus)</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        {showItemModal ? (
            <ComboItemsModal
                title="Select Menu Item for your combo"
                formik={formik}
                setShowItemModal={() => {
                  setShowItemModal(!showItemModal);
                }}
            />
        ) : (
            <></>
        )}
      </>
  );
};

export default UpdateCombo;